import { render, staticRenderFns } from "./AiWrapper.vue?vue&type=template&id=1f47c324&scoped=true&"
import script from "./AiWrapper.vue?vue&type=script&lang=js&"
export * from "./AiWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AiWrapper.vue?vue&type=style&index=0&id=1f47c324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f47c324",
  null
  
)

export default component.exports